import type { RecordFormData } from './types';

export const buildRecordPayload = (formData: RecordFormData): any => {
  const payload: any = {
    name: formData.name,
    type: formData.type,
    value: formData.value,
    ttl: parseInt(formData.ttl),
  };

  // Add MX priority
  if (formData.type === 'MX' && formData.priority) {
    payload.priority = parseInt(formData.priority);
  }

  // Add SRV fields
  if (formData.type === 'SRV') {
    payload.priority = parseInt(formData.priority);
    payload.weight = parseInt(formData.weight);
    payload.port = parseInt(formData.port);
  }

  // Add structured fields for complex record types
  if (formData.caa_flags !== '' || formData.caa_value) {
    payload.caa_flags = formData.caa_flags ? parseInt(formData.caa_flags) : undefined;
    payload.caa_tag = formData.caa_tag || undefined;
    payload.caa_value = formData.caa_value || undefined;
  }

  // Add other structured fields as needed...
  // (Simplified for now - can be expanded later)

  return payload;
};